<template>
    <a-tabs v-model:activeKey="activeTab" centered>
        <a-tab-pane key="1">
            <template #tab>
                <span>
                    <!-- <apple-outlined /> -->
                    组件库
                </span>
            </template>
            <div class="scrollBar" :style="{ height: '100%' }">
                <a-collapse v-model:activeKey="activeKey" :bordered="false" expandIconPosition="right"
                    style="background: #fff">
                    <a-collapse-panel key="1" header="容器">
                        <draggable tag="ul" :list="containers" item-key="key"
                            :group="{ name: 'dragGroup', pull: 'clone', put: false }" :clone="handleClone"
                            ghost-class="ghost" :sort="false" :move="checkMove">
                            <template #item="{ element }">
                                <div class="widget-item" @dblclick="addWidget(element)">
                                    <span>
                                        <!-- <svg-icon :icon-class="element.icon" class-name="color-svg-icon" /> -->
                                        {{ element.label }}
                                    </span>
                                </div>
                            </template>
                        </draggable>
                    </a-collapse-panel>
                    <a-collapse-panel key="2" header="字段">
                        <draggable tag="ul" :list="fields" item-key="key"
                            :group="{ name: 'dragGroup', pull: 'clone', put: false }" :clone="handleClone"
                            ghost-class="ghost" :sort="false" :move="checkMove">
                            <template #item="{ element }">
                                <div class="widget-item" @dblclick="addWidget(element)">
                                    <span>
                                        <!-- <svg-icon :icon-class="element.icon" class-name="color-svg-icon" /> -->
                                        {{ element.label }}
                                    </span>
                                </div>
                            </template>
                        </draggable>
                    </a-collapse-panel>
                </a-collapse>
            </div>
        </a-tab-pane>
        <a-tab-pane key="2">
            <template #tab>
                <span>
                    <!-- <android-outlined /> -->
                    表单模板
                </span>
            </template>
            <div class="scrollBar" :style="{ height: '100%' }">
                表单模板
            </div>
        </a-tab-pane>
    </a-tabs>
</template>

<script setup>
import { containers as CONS, fields as BFS } from "./config"
import { ref, computed, inject } from 'vue';
import { deepClone, generateId, getContainerByType } from "../../tools"

const activeTab = ref('1')
const activeKey = ref(['1', '2'])

const { getSelectWidget, getWidgetList, updateSelectWidget } = inject("designer")

const containers = computed(() => CONS.filter(con => {
    return !con.internal
}))
const fields = computed(() => BFS.filter(con => {
    return !con.internal
}))

const checkMove = (evt) => {
    if (!!evt.draggedContext && !!evt.draggedContext.element) {
        let wgType = evt.draggedContext.element.type + ''
        if (!!evt.to) {
            if (wgType === 'slot') {
                return false
            }
        }
    }

    return true
}

const handleClone = (origin) => {
    let newWidget = deepClone(origin)
    let tempId = generateId()
    newWidget.id = newWidget.type.replace(/-/g, '') + tempId
    newWidget.name = newWidget.id
    newWidget.label = newWidget.label || newWidget.type.toLowerCase()
    if (newWidget.type === 'grid') {
        let newCol = deepClone(getContainerByType(CONS, 'grid-col'))
        let tmpId = generateId()
        newCol.id = 'grid-col-' + tmpId
        newCol.name = 'gridCol' + tmpId
        newWidget.widgetList.push(newCol)
        newCol = deepClone(newCol)
        tmpId = generateId()
        newCol.id = 'grid-col-' + tmpId
        newCol.options.name = 'gridCol' + tmpId
        newWidget.widgetList.push(newCol)
        //   } else if (newWidget.type === 'table') {
        //     let newRow = {cols: []}
        //     newRow.id = 'table-row-' + generateId()
        //     newRow.merged = false
        //     let newCell = deepClone( this.getContainerByType('table-cell') )
        //     newCell.id = 'table-cell-' + generateId()
        //     newCell.options.name = newCell.id
        //     newCell.merged = false
        //     newCell.options.colspan = 1
        //     newCell.options.rowspan = 1
        //     newRow.cols.push(newCell)
        //     newWidget.rows.push(newRow)
        //   } else if (newWidget.type === 'tab') {
        //     let newTabPane = deepClone( this.getContainerByType('tab-pane') )
        //     newTabPane.id = 'tab-pane-' + generateId()
        //     newTabPane.options.name = 'tab1'
        //     newTabPane.options.label = 'tab 1'
        //     newWidget.tabs.push(newTabPane)
    }
    return newWidget
}

const addWidget = (widget) => {
    let newWidget = handleClone(widget)
    let selectedWidget = getSelectWidget()
    let widgetList = getWidgetList()
    if (!!selectedWidget && !!selectedWidget.widgetList) {
        selectedWidget.widgetList.push(newWidget)
    } else {
        widgetList.push(newWidget)
    }

    updateSelectWidget(newWidget)
}
</script>

<style lang="scss" scoped>
.ant-tabs {
    height: 100%;
}
::v-deep .ant-tabs-content {
    height: 100%;
}

::v-deep .ant-tabs-nav {
    margin: 0;
}

ul {
    margin: 0 !important;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.widget-item {
    flex-shrink: 0;
    height: 28px;
    line-height: 28px;
    width: 48%;
    margin-bottom: 6px;
    cursor: move;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    background: #f1f2f3;
}

.widget-item:hover {
    background: #EBEEF5;
    outline: 1px solid #8c8c8d;
}
</style>